module.exports = __webpack_public_path__ + "media/src/images/partners/gesis-d47b482cac9fda01579329b20bff2139.jpg";